import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/src/locale/pt';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        background: '#eceff1',
        primary: '#156b84',
        secondary: '#159957',
        toast: '#424242',
      },
      dark: {
        background: '#383838',
        primary: '#4c98ad',
        secondary: '#159957',
        toast: '#424242',
      },
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
});

export { vuetify };
